import { Center, Loader, Stack, Title } from '@mantine/core';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { useAnalysisType } from '@/api/analyses';
import { errorMessage } from '@/api/errors';
import { EmptyState } from '@/components/EmptyState';
import { usePageTitle } from '@/components/usePageTitle';
import { AnalysisTypeEditor } from '@/features/analyses/AnalysisTypeEditor';

export const Route = createFileRoute('/_staff/staff/analysis-types/$key')({ component: AnalysisTypePage });

function AnalysisTypePage() {
  const { t } = useTranslation('analyses');
  const { key } = Route.useParams();
  const navigate = useNavigate();
  const isNew = key === 'new';
  const type = useAnalysisType(isNew ? undefined : key);
  usePageTitle(isNew ? t('types.new') : key);
  if (!isNew && type.isPending)
    return (
      <Center py="xl">
        <Loader color="forest" />
      </Center>
    );
  if (!isNew && type.isError) return <EmptyState title={errorMessage(type.error)} />;
  return (
    <Stack gap="lg">
      <Title order={1}>{isNew ? t('types.new') : key}</Title>
      <AnalysisTypeEditor key={type.data?.updated_at ?? 'new'} initial={type.data} onSaved={(saved) => void navigate({ to: '/staff/analysis-types/$key', params: { key: saved.key } })} />
    </Stack>
  );
}
